import Tour from '../api/tour';
import * as mutation from '../mutations/tour';

const state = {
  tourIdx: 0,
  tourName: '',
  tourNationIdx: 0,
  tourNationName: '',
  tourNations: [],
  recommendContents: [],
  hotStore: [],
};

const getters = {
  tourIdx: state => state.tourIdx,
  tourName: state => state.tourName,
  tourNationIdx: state => state.tourNationIdx,
  tourNationName: state => state.tourNationName,
  tourNations: state => state.tourNations,
  recommendContents: state => state.recommendContents,
  hotStore: state => state.hotStore,
};

const actions = {
  selectTourHome ({ commit }, { idx, nationIdx, nationName }) {
    return Tour.getTourIdx(idx, nationIdx).then(response => {
      commit(mutation.SELECT_TOUR_HOME, { nationIdx, nationName, response });
    }).catch(err => {
      console.error(err);
    });
  },
  selectTourNations ({ commit }, idx) {
    return Tour.getTourIdxNations(idx).then(response => {
      commit(mutation.SELECT_TOUR_NATIONS, response.data);
    }).catch(err => {
      console.error(err);
    });
  },
  setTourNation ({ commit }, { idx, name }) {
    commit(mutation.SET_TOUR_NATION, { idx, name });
  },
  selectTourGuideMenu (context, { tourIdx, menuIdx, page, second, nationIdx, keyword }) {
    return Tour.getTourIdxMenuIdx(tourIdx, menuIdx, page, second, nationIdx, keyword);
  }
};

const mutations = {
  [mutation.SELECT_TOUR_HOME] (state, { nationIdx, nationName, response }) {
    state.tourIdx = response.data.tour.idx;
    state.tourName = response.data.tour.name;
    state.tourNationIdx = nationIdx;
    state.tourNationName = nationName;
    state.recommendContents = response.data.recommend_contents;
    state.hotStore = response.data.hot_store;
  },
  [mutation.SELECT_TOUR_NATIONS] (state, nations) {
    state.tourNations = nations;
  },
  [mutation.SET_TOUR_NATION] (state, { idx, name }) {
    state.tourNationIdx = idx;
    state.tourNationName = name;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
